import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "C:\\Users\\frontend\\Desktop\\Piaf-Vue 2\\Piaf-Vue\\node_modules\\@babel\\runtime-corejs3/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { DataListIcon, ThumbListIcon, ImageListIcon } from "../../../components/Svg";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import db from "@/components/firebaseInit";
import ImageListItem from "../../../components/Listing/ImageListItem";
import ThumbListItem from "../../../components/Listing/ThumbListItem";
import DataListItem from "../../../components/Listing/DataListItem";
import { apiUrl } from "../../../constants/config";
export default {
  components: {
    "data-list-icon": DataListIcon,
    "thumb-list-icon": ThumbListIcon,
    "image-list-icon": ImageListIcon,
    "v-select": vSelect,
    "image-list-item": ImageListItem,
    "thumb-list-item": ThumbListItem,
    "data-list-item": DataListItem
  },
  data: function data() {
    return {
      blogs: [],
      isLoad: false,
      apiBase: apiUrl + "/cakes/fordatatable",
      displayMode: "thumb",
      sort: {
        column: "title",
        label: "Product Name"
      },
      page: 1,
      perPage: 4,
      search: "",
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
      items: [],
      pageSizes: [4, 8, 12],
      selectedItems: [],
      categories: [{
        label: "Cakes",
        value: "Cakes"
      }, {
        label: "Cupcakes",
        value: "Cupcakes"
      }, {
        label: "Desserts",
        value: "Desserts"
      }],
      statuses: [{
        text: "ON HOLD",
        value: "ON HOLD"
      }, {
        text: "PROCESSED",
        value: "PROCESSED"
      }],
      newItem: {
        title: "",
        category: "",
        description: "",
        status: ""
      }
    };
  },
  methods: {
    loadItems: function loadItems() {
      var _this = this;

      this.isLoad = false;
      db.collection("blogs").get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            title: doc.data().title,
            date: doc.data().date,
            category: doc.data().category,
            img: doc.data().image
          };

          _this.blogs.push(data);

          _this.isLoad = true;
        });
      });
    },
    hideModal: function hideModal(refname) {
      this.$refs[refname].hide();
    },
    changeDisplayMode: function changeDisplayMode(displayType) {
      this.displayMode = displayType;
    },
    changePageSize: function changePageSize(perPage) {
      this.perPage = perPage;
    },
    changeOrderBy: function changeOrderBy(sort) {
      this.sort = sort;
    },
    addNewItem: function addNewItem() {
      console.log("adding item : ", this.newItem);
    },
    getIndex: function getIndex(value, arr, prop) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] === value) {
          return i;
        }
      }

      return -1;
    },
    toggleItem: function toggleItem(event, itemId) {
      if (event.shiftKey && this.selectedItems.length > 0) {
        var _this$selectedItems;

        var itemsForToggle = this.items;
        var start = this.getIndex(itemId, itemsForToggle, "id");
        var end = this.getIndex(this.selectedItems[this.selectedItems.length - 1], itemsForToggle, "id");
        itemsForToggle = itemsForToggle.slice(Math.min(start, end), Math.max(start, end) + 1);

        (_this$selectedItems = this.selectedItems).push.apply(_this$selectedItems, _toConsumableArray(itemsForToggle.map(function (item) {
          return item.id;
        })));
      } else {
        if (this.selectedItems.includes(itemId)) {
          this.selectedItems = this.selectedItems.filter(function (x) {
            return x !== itemId;
          });
        } else this.selectedItems.push(itemId);
      }
    },
    handleContextmenu: function handleContextmenu(vnode) {
      if (!this.selectedItems.includes(vnode.key)) {
        this.selectedItems = [vnode.key];
      }
    },
    onContextCopy: function onContextCopy() {
      console.log("context menu item clicked - Copy Items: ", this.selectedItems);
    },
    onContextArchive: function onContextArchive() {
      console.log("context menu item clicked - Move to Archive Items: ", this.selectedItems);
    },
    onContextDelete: function onContextDelete() {
      console.log("context menu item clicked - Delete Items: ", this.selectedItems);
    },
    linkGen: function linkGen(pageNum) {
      return "#page-" + pageNum;
    }
  },
  computed: {
    isSelectedAll: function isSelectedAll() {
      return this.selectedItems.length >= this.items.length;
    },
    isAnyItemSelected: function isAnyItemSelected() {
      return this.selectedItems.length > 0 && this.selectedItems.length < this.items.length;
    },
    apiUrl: function apiUrl() {
      return "".concat(this.apiBase, "?sort=").concat(this.sort.column, "&page=").concat(this.page, "&per_page=").concat(this.perPage, "&search=").concat(this.search);
    }
  },
  watch: {
    search: function search() {
      this.page = 1;
    },
    apiUrl: function apiUrl() {
      this.loadItems();
    }
  },
  mounted: function mounted() {
    this.loadItems();
  }
};